import React, {useState, useEffect, useMemo} from 'react'
import styled from 'styled-components';
import DepartmentCard from './DepartmentCard';
import { useSelector } from 'react-redux';

const Container = styled.div`
    display: flex;
    align-items: center;
    flex-direction: column;
    background: rgb(238,174,202);
    background: radial-gradient(circle, 
                                rgba(238,174,202,1) 0%, 
                                rgba(148,187,233,1) 100%);

`

const Header = styled.h1`
    flex: 1;
`

const ViewAllLink = styled.h1`
    flex: 1;
    border: 1px solid gray;
    border-radius: 10px;
    font-size: 20px;
    padding: 5px 20px;
    margin: 5px;
    cursor: pointer;
    background-color: black;
    color: white;
    &:hover{
        background-color: white;
        color: black;
    }
    visibility: ${props => props.show ? 'visible' : 'hidden'};
`

const CardsContainer = styled.div`
    display: flex;
    align-items: center;
    /*justify-content: space-around;*/
    gap: 10px;
    flex-wrap: wrap;
`

const SearchFilterInput = styled.input`
    visibility: ${props => props.show ? 'visible' : 'hidden'};
    
    height: 20px;
    /*width: 50%;*/
    padding: 10px;
    font-size: 20px;
    border-radius: 5px;

`

const SearchNotFound = styled.div`
    
    height: 20px;
    /*width: 50%;*/
    padding: 10px;
    color: red;
    font-size: 20px;
    visibility: ${props => props.show ? 'visible' : 'hidden'};
`

const ViewDepartments = ({limit}) => {

    const [limitNo, setLimitNo] = useState(limit ? Number(limit) : 0);
    const [deptListFiltered, setDeptListFiltered] = useState([]);
    const [searchFilter, setSearchFilter] = useState('');
    const [filterMsg, setFilterMsg] = useState('');
    const dept = useSelector(state => state.dept);
    const deptList = useMemo(() => [...dept?.departments], [dept?.departments]);
    deptList.reverse();

   

    useEffect(() => {
        //console.log('limit use effect');

        if(searchFilter && searchFilter.length > 0){
            const searchFilterData = deptList?.filter((item) => (
                item.deptName.toLowerCase()
                    .includes(searchFilter.toLowerCase()) ||
                    item.deptDesc.toLowerCase()
                    .includes(searchFilter.toLowerCase())
            ));

            if(limitNo > 0){
                const filterList = searchFilterData.slice(0, limitNo);
                setDeptListFiltered(filterList);
            }
            else{
                setDeptListFiltered(searchFilterData);
            }
            
            
        }
        else{
            if(limitNo > 0){
                const filterList = deptList.slice(0, limitNo);
                setDeptListFiltered(filterList);
            }
            else{
                setDeptListFiltered(deptList);
            }
            
        }
        
    }, [limitNo, deptList, searchFilter]);

    useEffect(() => {
        searchFilter?.length > 0 
            ? setFilterMsg(`${deptListFiltered.length > 0 ? deptListFiltered.length : 'No'} Results Found`) 
            : setFilterMsg('');
    }, [deptListFiltered, searchFilter])

   
    return (
        <Container>
            <Header>
                {(limitNo && limitNo > 0) ? 'Recent Departments' : 'All Departments' }
            </Header>

            <SearchFilterInput 
                show={!limitNo || limitNo === 0}
                placeholder='Search'
                onChange={(e) => setSearchFilter(e.target.value)}>
            </SearchFilterInput>
                
            <SearchNotFound show={filterMsg}>
                {filterMsg}
            </SearchNotFound> 

            <CardsContainer>
                {deptListFiltered.map((item, index) => (
                    <DepartmentCard key={index} department={item} />
                ))}
            </CardsContainer>
            <ViewAllLink show={limitNo && limitNo > 0} 
                            onClick={() => setLimitNo(0)}>
                Click To View All
            </ViewAllLink>
            
        </Container>
    )
}

export default ViewDepartments
